import { generatePath } from 'react-router'

import { WASTE_RECORD_DETAILS } from 'portal/routes'
import { PageContainer } from 'portal/pages/PageContainer'
import { RecordEdit } from 'portal/components/RecordsModules'
import { useModuleIds } from 'portal/lib/hooks'

export const WasteEdit = () => {
  const doneUri = useDoneRedirect()

  return (
    <PageContainer>
      <RecordEdit doneUri={doneUri} />
    </PageContainer>
  )
}

function useDoneRedirect() {
  const { accountId, projectId, recordId, moduleName } = useModuleIds()

  return generatePath(WASTE_RECORD_DETAILS, {
    accountId,
    projectId,
    recordId,
    moduleName
  })
}
